import navigationRoutes from "./navigationRoutes";
import HomePage from "@/projects/NPS/Stepper/pages/HomePage/home";
import Signup from "@/projects/NPS/Stepper/pages/SignUp";
import NewSubscriberRegistration from "@/projects/NPS/Stepper/pages/SubscriberRegistration";
import SubscriberRegistrationSummary from "@/projects/NPS/Stepper/pages/SubscriberRegistrationSummary";
import DigilockerCallbackPage from "@/projects/NPS/Stepper/pages/Digilocker/DigilockerCallbackPage";
import PranSuccessScreen from "@/projects/NPS/Stepper/pages/PranSuccessScreen";
import PaymentFailedScreen from "@/projects/NPS/Stepper/pages/PaymentFailedScreen";
import PrivacyPolicyPage from "@/projects/NPS/Stepper/pages/PrivacyPolicy";
import TermsAndConditionsPage from "@/projects/NPS/Stepper/pages/TermsAndConditions";

const protectedRoutes = [
  {
    path: navigationRoutes.NEW_SUBSCRIBER_REGISTRATION,
    element: NewSubscriberRegistration,
    name: "New Subscriber Registration",
  },
  {
    path: navigationRoutes.SUBSCRIBER_REGISTRATION_SUMMARY,
    element: SubscriberRegistrationSummary,
    name: "Subscriber Registration Summary",
  },
  {
    path: navigationRoutes.DIGILOCKER_CALLBACK,
    element: DigilockerCallbackPage,
    name: "Digilocker Callback",
  },
  {
    path: navigationRoutes.PRAN_SUCCESS_SCREEN,
    element: PranSuccessScreen,
    name: "Pran Success Screen",
  },
  {
    path: navigationRoutes.PAYMENT_FAILED_SCREEN,
    element: PaymentFailedScreen,
    name: "Payment Failed Screen",
  },
];

// Public routes that don't require authentication
const publicRoutes = [
  {
    path: navigationRoutes.LOGIN,
    element: HomePage,
    name: "NPS",
  },
  {
    path: navigationRoutes.SIGNUP,
    element: Signup,
    name: "Sign Up",
  },
  {
    path: navigationRoutes.PRIVACY_POLICY,
    element: PrivacyPolicyPage,
    name: "Privacy Policy",
  },
  {
    path: navigationRoutes.TERMS_AND_CONDITIONS,
    element: TermsAndConditionsPage,
    name: "Terms And Conditions",
  },
];

// Main routes configuration
const routes = [
  {
    type: "auth",
    routes: protectedRoutes,
  },
  {
    type: "public",
    routes: publicRoutes,
  },
];

export default routes;
export { navigationRoutes };
